//IMPORTAÇÃO DAS BIBLIOTECAS-----------------------------------------------------------------------
import React, { useState } from 'react';
import { api } from '../../../services/api';
import styles from './ForgotPasswordModal.module.css';
import { useTranslation } from 'react-i18next';



// COMPONENTE--------------------------------------------------------------------------------------
const ForgotPasswordModal = ({ isOpen, onClose }) => {
  // idioma
  const { t } = useTranslation();

  // variáveis
  const [forgotPasswordEmail, setForgotPasswordEmail] = useState('');
  const [modalMessage, setModalMessage] = useState('');
  const [isSendingLink, setIsSendingLink] = useState(false);
  const [isLinkSent, setIsLinkSent] = useState(false);



  // função para enviar o link de rededinição de senha para o email
  const handleForgotPasswordSubmit = async (e) => {
    e.preventDefault();
    setIsSendingLink(true);
    setModalMessage('');
    setIsLinkSent(false);

    try {
      // A API deve sempre retornar sucesso para não revelar e-mails cadastrados
      await api.post('/auth/forgot-password', { email: forgotPasswordEmail });
      // console.log(response.data.msg); // para desenvolvimento
      setModalMessage(t("If a matching email is found, a password reset link will be sent.")); // traduzir para inglês
      setIsLinkSent(true);
    } catch (error) {
      // Mesmo em caso de erro, exibimos a mesma mensagem por segurança.
      // console.error("Erro ao solicitar redefinição de senha:", error); // para desenvolvimento
      setModalMessage(t("If a matching email is found, a password reset link will be sent."));
      setIsLinkSent(true);
    } finally {
      setIsSendingLink(false);
    }
  };

  // função para cancelar
  const handleCancel = () => {
    onClose();
    setForgotPasswordEmail('');
    setModalMessage('');
    setIsLinkSent(false);
  };

  // função para fechar o modal
  if (!isOpen) return null;

  return (
    <div className={styles.modalOverlay}>
      <div className={styles.modalContent}>
        <button onClick={handleCancel} className={styles.modalCloseButton}>&times;</button>
        <h2>{t("Recover Password")}</h2>
        <p>{t("Enter your email to receive a password reset link.")}</p>
        <form onSubmit={handleForgotPasswordSubmit} className={styles.form}>
          <input
            type="email"
            aria-label={t('Registration email')}
            placeholder={t('Registration email')}
            value={forgotPasswordEmail}
            onChange={(e) => setForgotPasswordEmail(e.target.value)}
            required
            className={styles.input}
          />
          {modalMessage && (
            <div className={`${styles.modalMessage} ${isLinkSent ? styles.success : styles.error}`}>
              <p>{modalMessage}</p>
            </div>
          )}
          <button type="submit" className={styles.button} disabled={isSendingLink || isLinkSent}>
            {isSendingLink ? t("Sending link...") : t("Send Link")}
          </button>
        </form>
      </div>
    </div>
  );
};

export default ForgotPasswordModal;